import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'nominas/tipos-de-suspensiones-de-pagos';

/**
 * GET Motivos de Suspensiones de Pagos
 * @param {object} params
 * @returns {Promiser<object[]>}
 */
export const getTiposDeSuspensionesDePagos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Motivo de Suspension de Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeSuspensionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
